import { forwardRef as i, createElement as a, Fragment as o } from "react";
var t = function t(i) {
    return function () {
      for (var i = [], a = 0; a < arguments.length; a++) i[a] = arguments[a];
      return i.filter(Boolean).join(" ");
    }("svg-inline--fa", "fa-".concat(i.icon.iconName), "fa-w-".concat(Math.ceil(i.icon.icon[0] / i.icon.icon[1] * 16)), i.size && "fa-".concat(i.size), i.border && "fa-border", i.fixedWidth && "fa-fw", i.flip && "fa-flip-".concat(i.flip), i.spin && "fa-spin", i.pulse && "fa-pulse", i.inverse && "fa-inverse", i.listItem && "fa-li", i.pull && "fa-pull-".concat(i.pull), i.swapOpacity && "fa-swap-opacity", i.rotation && "fa-rotate-".concat(i.rotation), i.className);
  },
  n = ["icon", "size", "className", "title", "border", "fixedWidth", "flip", "spin", "pulse", "inverse", "listItem", "pull", "swapOpacity", "rotation", "role", "symbol"],
  e = {
    style: {
      display: "none"
    }
  },
  l = i(function (i, l) {
    var r = i.icon;
    if (!r) return null;
    var c = r.icon,
      s = c[0],
      f = c[1],
      p = c[4],
      u = i.title ? Math.random().toString(36).substr(2) : void 0,
      d = function (i, a) {
        var o = {};
        for (var t in i) Object.hasOwnProperty.call(i, t) && !a.includes(t) && (o[t] = i[t]);
        return o;
      }(i, n);
    d.className = t(i), d.xmlns = "http://www.w3.org/2000/svg", d["aria-labelledby"] = u, d["aria-hidden"] = !u || void 0, d.focusable = !!u && void 0, d.ref = l, d.viewBox = "0 0 ".concat(s, " ").concat(f), d.role = i.role || "img";
    var v = i.symbol || !1,
      m = a(o, null, u && a("title", {
        id: u
      }, i.title), a("path", {
        fill: "currentColor",
        d: p.toString()
      }));
    return v ? (d.id = !0 === v ? "".concat(r.prefix, "-").concat(r.iconName) : v, a("svg", e, a("symbol", d, m))) : a("svg", d, m);
  });
l.displayName = "FontAwesomeSvgIcon";
export { l as FontAwesomeSvgIcon };